import Component from './route-component';
import Enhance from '../core/enhance'
import tools from '../libs/tools';
import classnames from 'classnames';
import Router from './router';
import React from 'react'
const isModifiedEvent = (event) =>
    !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey)

/**
 *
 */
class RouteNav extends Component {

    handleClick = (event) => {
        let location = this.location();
        if (this.props.onClick)
            this.props.onClick(event)
        if (
            !event.defaultPrevented && // onClick prevented default
            event.button === 0 && // ignore everything but left clicks
            !this.props.target && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
        ) {
            event.preventDefault()
            const {replace, hash, search} = this.props;
            // if (!tools.empty(search)) {
            //     let params1 = {};
            //     let params2 = {};
            //     tools.parse_str(search, params1);
            //     tools.parse_str(window.location.search.substring(1), params2);
            //     let url = tools.http_build_query($.extend({}, params2, params1));
            //
            //     //let url = (window.location.search ? window.location.search + '&' : '?') + search;
            // }
            // else
            if (hash) {
                Router.replace('#' + hash, location.state);
            }
        }
    }

    /**
     *
     * @return {*}
     */
    render() {
        let active = false;
        let location = this.location();
        let {hash} = location;
        active = hash === '#' + this.props.hash || (!hash && this.props.default === true)
        return (
            <a
                className={classnames('c-route-nav', this.props.className, {active})}
                style={this.props.style}
                onClick={this.handleClick}
            >
                {this.props.children}
            </a>
        );
    }
}

Enhance(RouteNav, {}, 'RouteNav');
export default RouteNav
